import React, { useState } from 'react';
import './ResellersApplicationForm.scss';
import Form from '../UI/Form/Form';
import { useForm } from 'react-hook-form';
import { emailPattern } from '../../util/regex/emailPattern';
import { phonePattern } from '../../util/regex/phonePattern';
import ErrorMessage from '../Footer/NewsletterSignUp/ErrorMessage/ErrorMessage';
import Select from '../UI/Select/Select';
import CTAButton from '../UI/CTA/CTAButton/CTAButton';
import { HUBSPOT_FORM_CONFIG } from '../../constants/hubspotFormConfig';
import FormSuccessMessage from '../UI/Form/FormSuccessMessage/FormSuccessMessage';
import { countriesList } from '../../util/countriesList';

const ResellersApplicationForm = ({ title, ctaText, successTitle, successMessage, disclaimer }) => {
  const { register, handleSubmit, errors, trigger, formState } = useForm({ mode: 'onChange' });
  const [formComplete, setFormComplete] = useState(false);
  const [status, setStatus] = useState(null);

  const rows = [
    <div className="c-form__row">
      <div className="c-form__input-container">
        <label htmlFor="firstname" className="c-form__input-label eyebrow-2">
          FIRST NAME
        </label>
        <input
          id={'firstname'}
          name={'firstname'}
          className={`body-2 color-black c-form__input ${errors['firstname'] ? 'error' : ''}`}
          type="text"
          ref={register({
            required: true,
          })}
          onBlur={() => trigger('firstname')}
        />
        {errors['firstname'] && <ErrorMessage message={'First name is required'} />}
      </div>
      <div className="c-form__input-container">
        <label htmlFor="lastname" className="c-form__input-label eyebrow-2">
          LAST NAME
        </label>
        <input
          id={'lastname'}
          name={'lastname'}
          className={`body-2 color-black c-form__input ${errors['lastname'] ? 'error' : ''}`}
          type="text"
          ref={register({
            required: true,
          })}
          onBlur={() => trigger('lastname')}
        />
        {errors['lastname'] && <ErrorMessage message={'Last name is required'} />}
      </div>
    </div>,
    <div className="c-form__row">
      <div className="c-form__input-container">
        <label htmlFor="company" className="c-form__input-label eyebrow-2">
          COMPANY NAME
        </label>
        <input
          id={'company'}
          name={'company'}
          className={`body-2 color-black c-form__input ${errors['company'] ? 'error' : ''}`}
          type="text"
          ref={register({
            required: true,
          })}
          onBlur={() => trigger('company')}
        />
        {errors['company'] && <ErrorMessage message={'Company name is required'} />}
      </div>
      <div className="c-form__input-container">
        <label htmlFor="jobtitle" className="c-form__input-label eyebrow-2">
          JOB TITLE
        </label>
        <input
          id={'jobtitle'}
          name={'jobtitle'}
          className={`body-2 color-black c-form__input ${errors['jobtitle'] ? 'error' : ''}`}
          type="text"
          ref={register}
          onBlur={() => trigger('jobtitle')}
        />
        {errors['jobtitle'] && <ErrorMessage message={'Please enter a valid job title'} />}
      </div>
    </div>,
    <div className="c-form__row">
      <div className="c-form__input-container">
        <label htmlFor="email" className="c-form__input-label eyebrow-2">
          BUSINESS EMAIL
        </label>
        <input
          id={'email'}
          name={'email'}
          className={`body-2 color-black c-form__input ${errors['email'] ? 'error' : ''}`}
          type="email"
          ref={register({
            required: true,
            pattern: emailPattern,
          })}
          onBlur={() => trigger('email')}
        />
        {errors['email'] && <ErrorMessage message={'Please enter a valid email address'} />}
      </div>
      <div className="c-form__input-container">
        <label htmlFor="phone" className="c-form__input-label eyebrow-2">
          PHONE NUMBER
        </label>
        <input
          id={'phone'}
          name={'phone'}
          className={`body-2 color-black c-form__input ${errors['phone'] ? 'error' : ''}`}
          type="text"
          ref={register({
            required: true,
            pattern: phonePattern,
          })}
          onBlur={() => trigger('phone')}
        />
        {errors['phone'] && <ErrorMessage message={'Please enter a valid phone number'} />}
      </div>
    </div>,
    <div className="c-form__row">
      <div className="c-form__input-container">
        <label htmlFor="address" className="c-form__input-label eyebrow-2">
          STREET ADDRESS
        </label>
        <input
          id={'address'}
          name={'address'}
          className={`body-2 color-black c-form__input ${errors['address'] ? 'error' : ''}`}
          type="text"
          ref={register}
          onBlur={() => trigger('address')}
        />
        {errors['address'] && <ErrorMessage message={'Please enter a valid street address'} />}
      </div>
    </div>,
    <div className="c-form__row">
      <div className="c-form__input-container">
        <label htmlFor="city" className="c-form__input-label eyebrow-2">
          CITY
        </label>
        <input
          id={'city'}
          name={'city'}
          className={`body-2 color-black c-form__input ${errors['city'] ? 'error' : ''}`}
          type="text"
          ref={register}
          onBlur={() => trigger('city')}
        />
        {errors['city'] && <ErrorMessage message={'Please enter a valid city'} />}
      </div>
      <div className="c-form__input-container">
        <label htmlFor="state" className="c-form__input-label eyebrow-2">
          STATE/REGION
        </label>
        <input
          id={'state'}
          name={'state'}
          className={`body-2 color-black c-form__input ${errors['state'] ? 'error' : ''}`}
          type="text"
          ref={register}
          onBlur={() => trigger('state')}
        />
        {errors['state'] && <ErrorMessage message={'Please enter a valid street state'} />}
      </div>
    </div>,
    <div className="c-form__row">
      <div className="c-form__input-container select-element">
        <Select
          fieldRef={register({ required: true })}
          label={'COUNTRY'}
          type={'translucent'}
          data={countriesList}
          id={'country'}
          fieldName={'country'}
          onChange={() => trigger('country')}
        />
        {errors['country'] && <ErrorMessage message={'Country is required'} />}
      </div>
    </div>,
    <div className="c-form__row">
      <div className="c-form__input-container">
        <label
          htmlFor="what_industries_do_your_primarily_service_"
          className="c-form__input-label eyebrow-2"
        >
          PRIMARY INDUSTRIES SERVED
        </label>
        <input
          id={'what_industries_do_your_primarily_service_'}
          name={'what_industries_do_your_primarily_service_'}
          className={`body-2 color-black c-form__input ${
            errors['what_industries_do_your_primarily_service_'] ? 'error' : ''
          }`}
          type="text"
          ref={register({
            required: true,
          })}
          onBlur={() => trigger('what_industries_do_your_primarily_service_')}
        />
        {errors['what_industries_do_your_primarily_service_'] && (
          <ErrorMessage message={'This field is required'} />
        )}
      </div>
    </div>,
    <div className="c-form__row">
      <div className="c-form__input-container">
        <label
          htmlFor="how_many_video_conferencing_hardware_deals_do_you_close_per_month_"
          className="c-form__input-label eyebrow-2"
        >
          # OF VIDEO CONFERENCING DEALS/MONTH
        </label>
        <input
          id={'how_many_video_conferencing_hardware_deals_do_you_close_per_month_'}
          name={'how_many_video_conferencing_hardware_deals_do_you_close_per_month_'}
          className={`body-2 color-black c-form__input ${
            errors['how_many_video_conferencing_hardware_deals_do_you_close_per_month_']
              ? 'error'
              : ''
          }`}
          type="number"
          min="1"
          ref={register({
            required: true,
          })}
          onBlur={() =>
            trigger('how_many_video_conferencing_hardware_deals_do_you_close_per_month_')
          }
        />
        {errors['how_many_video_conferencing_hardware_deals_do_you_close_per_month_'] && (
          <ErrorMessage message={'This is a required field'} />
        )}
      </div>
    </div>,
    <div className="c-form__row">
      <div className="c-form__input-container">
        <label
          htmlFor="what_is_the_average_deal_size_how_many_units_"
          className="c-form__input-label eyebrow-2"
        >
          AVERAGE # OF UNITS SOLD
        </label>
        <input
          id={'what_is_the_average_deal_size_how_many_units_'}
          name={'what_is_the_average_deal_size_how_many_units_'}
          className={`body-2 color-black c-form__input ${
            errors['what_is_the_average_deal_size_how_many_units_'] ? 'error' : ''
          }`}
          type="text"
          ref={register({
            required: true,
          })}
          onBlur={() => trigger('what_is_the_average_deal_size_how_many_units_')}
        />
        {errors['what_is_the_average_deal_size_how_many_units_'] && (
          <ErrorMessage message={'This field is required'} />
        )}
      </div>
    </div>,
    <div className="c-form__row">
      <div className="c-form__input-container checkbox">
        <input
          id={'are_you_a_video_conferencing_channel_partner_'}
          name={'are_you_a_video_conferencing_channel_partner_'}
          className="body-2 color-black c-form__input-checkbox"
          type="checkbox"
          ref={register()}
          onBlur={() => trigger('are_you_a_video_conferencing_channel_partner_')}
        />
        <label
          htmlFor="are_you_a_video_conferencing_channel_partner_"
          className="c-form__input-label body-2"
        >
          Please click to confirm you are a video conferencing channel partner or reseller.
        </label>
      </div>
    </div>,
    <input ref={register} name="lead_type" type="hidden" value="reseller_lead" />,
    <input ref={register} name="lifecyclestage" type="hidden" value="marketingqualifiedlead" />,
    <input ref={register} name="sales_request" type="hidden" value="Reseller Application" />,
    <div className="c-form__row">
      <CTAButton
        type={'primary'}
        name={'submit'}
        text={ctaText}
        additionalClasses={'c-form__submit cta'}
        isButton={true}
        buttonType={'submit'}
        disabled={!formState.isValid}
      />
    </div>,
  ];

  return (
    <div id="apply-now" className="c-resellers-application-form background-color-orange">
      <div className="c-resellers-application-form__inner">
        <div className="c-resellers-application-form__title h4-right-grotesk">
          <h4>{title}</h4>
        </div>
        <div className="c-resellers-application-form__form-container background-color-white">
          {!formComplete && (
            <>
              <Form
                handleSubmit={handleSubmit}
                guid={HUBSPOT_FORM_CONFIG.RESELLERS.GUID}
                ctaText={ctaText}
                rows={rows}
                setFormComplete={setFormComplete}
                setStatus={setStatus}
              />
              <div
                className="c-resellers-application-form__disclaimer body-3 color-black"
                dangerouslySetInnerHTML={{ __html: disclaimer }}
              ></div>
            </>
          )}
          {formComplete && <FormSuccessMessage title={successTitle} message={successMessage} />}
        </div>
      </div>
    </div>
  );
};

export default ResellersApplicationForm;
